import React from "react";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { CssBaseline } from "@mui/material";
import { lightTheme, darkTheme } from "../constants/theme.ts";
import { useTheme } from "../contexts/ThemeContext.tsx";

const ThemeProvider = ({ children }) => {
  const { darkMode } = useTheme() || { darkMode: false };
  const theme = darkMode ? darkTheme : lightTheme;

  return (
    <StyledThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </StyledThemeProvider>
  );
};

export default ThemeProvider;
